export default[
    {
        id: 1,
        name: 'jord ali',
        text: `I love creating new think every single days so 
        let’s do it together it was wonderful to work with you.`,
        image: '../assets/hero.png'
    },
    {
        id: 2,
        name: 'taro zizo',
        text: `I love creating new think every single days so 
        let’s do it together it was wonderful to work with you.`,
        image: '../assets/hero.png'
    },
    {
        id: 3,
        name: 'ali dae',
        text: `I love creating new think every single days so 
        let’s do it together it was wonderful to work with you.`,
        image: '../assets/hero.png'
    },
    {
        id: 4,
        name: 'ken wiwa',
        text: `I love creating new think every single days so 
        let’s do it together it was wonderful to work with you.`,
        image: '../assets/hero.png'
    },
    {
        id: 5,
        name: 'john doe',
        text: `I love creating new think every single days so 
        let’s do it together it was wonderful to work with you.`,
        image: '../assets/hero.png'
    },
    {
        id: 6,
        name: 'mark huut',
        text: `I love creating new think every single days so 
        let’s do it together it was wonderful to work with you.`,
        image: '../assets/hero.png'
    },
    {
        slide:[ 
        {
            id:1,
            url: '../assets/Rectangle54.png',
        },
        {
            id:1,
            url: '../assets/Rectangle540.png'
        },
        {
            id:1,
            url: '../assets/Rectangle544.png'
        },
        {
            id:1,
            url: '../assets/Rectangle543.png'
        }
    ]
    }
]